export default __webpack_public_path__ + "locales/pt-BR/FilesSettings.json?hash=daf9c81229d8cf739ce5cbbe40a94a50";